import { render, staticRenderFns } from "./Postgrado-add.vue?vue&type=template&id=3ddaafa5&scoped=true"
import script from "./Postgrado-add.vue?vue&type=script&lang=js"
export * from "./Postgrado-add.vue?vue&type=script&lang=js"
import style0 from "./Postgrado-add.vue?vue&type=style&index=0&id=3ddaafa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddaafa5",
  null
  
)

export default component.exports